import { useCallback, useMemo } from 'react'
import { FileCheck2 } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchLegalBasis, LEGAL_KIND_OPTS, LEGAL_STATUS_OPTS, LEGAL_STR as S, type LegalRow } from './legalFlowApi'

/**
 * A19.03 — Huquqiy asos tekshiruvi (legal-basis check, read-only). Har huquqiy
 * so'rovning asosini (tur/organ/referens/yurisdiksiya) ko'rish. GET /admin/legal
 * ustidan. Backend yo'q/xato → fail-soft (bo'sh).
 */
export function LegalBasisScreen() {
  const columns = useMemo<AdminColumn<LegalRow>[]>(
    () => [
      { key: 'id', header: S.id, type: 'id', width: 70 },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
      { key: 'kind', header: S.kind, type: 'enum', width: 140, options: LEGAL_KIND_OPTS },
      { key: 'authority', header: S.authority, type: 'text', minWidth: 180 },
      { key: 'reference', header: S.reference, type: 'text', width: 150 },
      { key: 'jurisdiction', header: S.jurisdiction, type: 'text', width: 150 },
      { key: 'status', header: S.status, type: 'enum', width: 130, options: LEGAL_STATUS_OPTS },
    ],
    [],
  )
  const fetcher = useCallback(fetchLegalBasis, [])
  return (
    <>
      <PageHeader title={S.basisTitle} screenId="A19.03" description={S.basisDesc} />
      <DataTable<LegalRow>
        screenId="A19.03"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <FileCheck2 size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
